// localStorage может быть недоступен (приватный режим) — тогда просто ничего не запоминаем
export const store = {
  get<T>(key: string, fallback: T): T {
    try {
      const v = localStorage.getItem(key);
      return v === null ? fallback : (JSON.parse(v) as T);
    } catch {
      return fallback;
    }
  },
  set(key: string, value: unknown): void {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch {
      // нет хранилища — не запоминаем
    }
  },
};

// Анонимный идентификатор браузера: к нему привязаны подписки и Telegram
export const clientId: string = (() => {
  let id = store.get<string | null>('clientId', null);
  if (!id) {
    id = typeof crypto !== 'undefined' && crypto.randomUUID
      ? crypto.randomUUID()
      : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`;
    store.set('clientId', id);
  }
  return id;
})();
